CANDYRACK_DOCUMENT_LISTENER = true;
CANDYRACK_DISABLE_FORM_VALIDATION = true;
CANDYRACK_LISTEN_FOR_TOUCHEND_EVENT = true;



const parsePrice = (price) => {
  return  Number(price.replace(/[^0-9\.]+/g,""));
}


const convertMoney = async (el, selector) => {
   const priceString = el.querySelector(selector)

   const price = parsePrice(priceString.innerText)

   const {Currency} = await GIP.getLocalizeData()

   const priceData = await $.ajax({
          method: "POST",
          url: "https://checkout.gointerpay.net/v2.18/localize",
          headers: {"Content-Type": "application/x-www-form-urlencoded"},
          data: 'MerchantId=1422f901-564b-46c7-93cd-4120e89bab73&Currency='+Currency+'&MerchantPrices='+encodeURIComponent('[{"Price":'+(String(price))+',"Tag":"autoroun"}]')
        })

      if (priceData.ConsumerPrices[0] === null) {
          const newPrice = priceData.Symbol+price+".00";
          priceString.innerText = newPrice
      } else {
          const newPrice = priceData.Symbol+priceData.ConsumerPrices[0]+".00 "+priceData.Currency;
          priceString.innerText = newPrice
      }
}

document.addEventListener("addToCartButtonClicked", () => {
console.log('addToCartButtonClicked');

    const customInterval= setInterval(() => {
    const popupCR = document.querySelector("#candyrack-frame")
    const canAccess = popupCR && popupCR.contentWindow && popupCR.contentWindow.document && popupCR.contentWindow.document.body
    const upsells = canAccess && popupCR.contentWindow.document.body.querySelectorAll("li.Upsell-Item")
    const parent = canAccess && popupCR.contentWindow.document.body.querySelector("div.Product-Line")
    if(popupCR && parent && upsells.length && [...upsells].every(u => !!u.querySelector(".Offer-Price span"))) {


        convertMoney(parent, ".Product-Price span")


        upsells.forEach(u => convertMoney(u, ".Offer-Price span"))

        upsells.forEach(u => {
          if(u.querySelector(".Offer-Price-Before-Discount span")) {
              convertMoney(u, ".Offer-Price-Before-Discount span")
           }
        }) 

        clearInterval(customInterval)

    }


},100)
})
